import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import Root from './App';
import reportWebVitals from './reportWebVitals';
import { installAuthenticatedFetch } from './utils/installAuthenticatedFetch';
import { installGlobalErrorHandlers } from './errors/installGlobalErrorHandlers';

// Before anything else, so failures during the rest of boot are reported.
installGlobalErrorHandlers();
installAuthenticatedFetch();

const container = document.getElementById('root') as HTMLElement;
const app = (
  // <React.StrictMode>
    <Root />
  // </React.StrictMode>
);

/* Public pages arrive prerendered, but as a Puppeteer snapshot taken after
   effects ran, with no Suspense markers. That can never hydrate, so the
   snapshot serves crawlers and first paint and React replaces it. */
createRoot(container).render(app);

// Initialize background video source
(() => {

})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
